import React from 'react';

const About: React.FC = () => {
  return (
    <section className="py-32 bg-white relative overflow-hidden" id="about">
      {/* 背景装飾 */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-72 h-72 bg-purple-600 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-fuchsia-600 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* 左側：画像 */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-3xl shadow-2xl border-4 border-purple-900/20">
              <img 
                src="https://readdy.ai/api/search-image?query=Abstract%20elegant%20purple%20violet%20geometric%20shapes%20modern%20digital%20technology%20concept%20sophisticated%203D%20design%20futuristic%20architecture%20minimalist%20composition%20professional%20atmosphere%20no%20people&width=800&height=1000&seq=about-geometric-abstract-3101&orientation=portrait"
                alt="合同会社SASAICHI"
                className="w-full h-[600px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-purple-900/80 via-transparent to-transparent"></div>
            </div>
            {/* 装飾的な要素 */}
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-gradient-to-br from-fuchsia-400/30 to-violet-500/30 rounded-full blur-2xl"></div>
            <div className="absolute -top-8 -left-8 w-48 h-48 bg-gradient-to-br from-purple-400/30 to-fuchsia-400/30 rounded-full blur-2xl"></div>
          </div>

          {/* 右側：テキスト */}
          <div>
            <div className="inline-block mb-6 px-8 py-3 bg-gradient-to-r from-purple-900 to-violet-900 rounded-full border-2 border-fuchsia-400">
              <span className="text-purple-100 text-sm font-black tracking-widest" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                ABOUT US
              </span>
            </div>
            
            <h2 className="text-5xl md:text-6xl font-black text-purple-900 mb-8" style={{ fontFamily: '"Shippori Mincho", serif' }}>
              会社概要
            </h2>

            <div className="space-y-6 mb-12">
              <p className="text-xl text-stone-700 leading-relaxed font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                合同会社SASAICHIは、神奈川県横須賀市を拠点に、<strong>ウェブコンテンツ事業</strong>を展開しています。
              </p>
              <p className="text-lg text-stone-600 leading-relaxed" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                企画から制作、管理・運営、販売、プロデュースまで、デジタルコンテンツに関わる全てのプロセスをワンストップでサポート。お客様のビジネスを次のステージへと導きます。
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-fuchsia-50 rounded-3xl p-8 border-2 border-purple-100 shadow-lg">
              <div className="space-y-6">
                {[
                  { label: '会社名', value: '合同会社SASAICHI' },
                  { label: '所在地', value: '神奈川県横須賀市湘南鷹取六丁目１４番１３号' },
                  { label: '事業内容', value: 'ウェブコンテンツ事業' }
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-6 pb-6 border-b border-purple-200 last:border-b-0 last:pb-0">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-gradient-to-br from-fuchsia-400 to-violet-500 rounded-xl flex items-center justify-center">
                        <i className="ri-building-line text-2xl text-white w-6 h-6 flex items-center justify-center"></i>
                      </div>
                    </div>
                    <div className="flex-1">
                      <dt className="text-sm font-black text-purple-900 mb-2 tracking-wider" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                        {item.label}
                      </dt>
                      <dd className="text-lg text-stone-700 font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                        {item.value}
                      </dd>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
